import MuiTooltip, { TooltipProps } from "@mui/material/Tooltip";
import { CSSTextAlign } from "core/types";
import { ReactNode } from "react";

export default function Tooltip({
  children,
  enterDelay,
  isHoverable,
  open,
  placement,
  testId,
  title,
  tooltipTextAlign = "left",
}: Omit<TooltipProps, "title"> & {
  children?: ReactNode;
  isHoverable?: boolean;
  testId?: string;
  title?: TooltipProps["title"] | string | null | undefined;
  tooltipTextAlign?: CSSTextAlign;
}) {
  if (!title) return <>{children}</>;

  return (
    <MuiTooltip
      className="tooltip"
      data-testid={testId}
      enterDelay={enterDelay}
      open={open}
      placement={placement}
      PopperProps={{
        style: {
          pointerEvents: isHoverable ? "auto" : "none",
          textAlign: tooltipTextAlign,
        },
      }}
      slotProps={{ tooltip: { style: { pointerEvents: "none" } } }}
      title={title}
    >
      {children}
    </MuiTooltip>
  );
}
